// src/components/FilterForm.jsx

import React from 'react';
import './FilterForm.css';

const FilterForm = ({ filter, handleFilterChange, vehicleModels }) => (
    <section className="filters">
        <label>
            Start Date:
            <input
                type="date"
                name="startDate"
                value={filter.startDate}
                onChange={handleFilterChange}
                aria-label="Start Date"
            />
        </label>
        <label>
            End Date:
            <input
                type="date"
                name="endDate"
                value={filter.endDate}
                onChange={handleFilterChange}
                aria-label="End Date"
            />
        </label>
        <label>
            Vehicle Model:
            <select
                name="vehicleModel"
                value={filter.vehicleModel}
                onChange={handleFilterChange}
                aria-label="Vehicle Model"
            >
                <option value="">All</option>
                {vehicleModels.map((model) => (
                    <option key={model.name} value={model.name}>
                        {model.name}
                    </option>
                ))}
            </select>
        </label>
    </section>
);

export default React.memo(FilterForm);
